/** Replace `public/logo.png` with your own logo file (PNG recommended). */
export const LOGO_SRC = `${process.env.PUBLIC_URL || ''}/logo.png`;

/** Site-wide page background images (bright, readable under PageBackdrop scrim). */
export const PAGE_BACKGROUNDS = {
  home: 'https://images.unsplash.com/photo-1485846234645-a62644f84728?w=2400&q=90',
  courses: 'https://images.unsplash.com/photo-1536440136628-849c177e76a1?w=2400&q=85',
  internships: 'https://images.pexels.com/photos/7991579/pexels-photo-7991579.jpeg?auto=compress&cs=tinysrgb&w=2400',
  newsletter: 'https://images.unsplash.com/photo-1636382119289-957f817cbfbc?w=2400&q=90',
  about: 'https://images.unsplash.com/photo-1517604931442-7e0c8ed2963c?w=2400&q=85',
  contact: 'https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?w=2400&q=85',
  masterclasses: 'https://images.unsplash.com/photo-1598899134739-24c46f58b8c0?w=2000&q=85',
};
